import React, { useEffect } from "react";
import styles from "./ReferralManage.module.css";
import { apiUrl } from "../../Constants/Constants";
import { toast } from "react-toastify";
import { useFetchWithToken } from "../FetchWithToken/FetchWithToken";
import { AuthContext } from "../../Constants/AuthProvider";
import { toPersian } from "../../Utility/Utilities";
import { useClipboard } from "../../Utility/Utilities";
import SeperatorBlue from "../SeperatorBlue/SeperatorBlue.module";
const ReferralManage = ({ account, loadingShow }) => {
  const { copied, copy } = useClipboard();
  const handleCopy = async (text) => {
    const ok = await copy(text);
  };
  useEffect(() => {
    if (copied) {
      toast.success("متن کپی شد!");
    }
  }, [copied]);
  return (
    <>
      <div className={styles.referralBox}>
        <div className={styles.boxOfTitle}>
          <div className={styles.referralTitle}>
            <i class="fa-regular fa-users-medical"></i>
            دعـوت از دوسـتان
          </div>
          <div className={styles.infoleft}>
            <i class="fa-regular fa-circle-info"></i>
          </div>
        </div>

        <div className={styles.roundContainBlue}>
          <div className={styles.eachItemContainB}>
            کد ریفرال
            <div className={styles.whiteLabelBox}>
              <div
                className={styles.copyIcon}
                onClick={() => handleCopy(account?.referral?.referralCode)}
              >
                <i class="fa-regular fa-copy"></i>
              </div>
              {account?.referral?.referralCode}
            </div>
          </div>
          <div className={styles.eachItemContainB}>
            پسورد ریفرال
            <div className={styles.whiteLabelBox}>
              <div
                className={styles.copyIcon}
                onClick={() => handleCopy(account?.referral?.referralPassword)}
              >
                <i class="fa-regular fa-copy"></i>
              </div>
              {account?.referral?.referralPassword}
            </div>
          </div>
        </div>
        <div className={styles.topwhiter}>
          <div className={styles.infoAllowed}>
            <div className={styles.allowedLabel}>
              دفعات مجاز باقی مانده دعوت:
            </div>
            <div className={styles.allowedCount}>
              {toPersian(
                account?.referral?.referralsAllowed -
                  account?.referral?.referralUsed
              )}
            </div>
          </div>
          <div className={styles.blsp}></div>
          <div
            className={styles.friendTextBox}
            onClick={() => handleCopy(account?.referral?.referralText)}
          >
            <div className={styles.friendTextBoxTitle}>
              متن پیشنهادی جهت ارسال به دوستان: <br />
              (جهت کپی برروی متن ضربه بزنید)
            </div>
            <div className={styles.realText}>
              {account?.referral?.referralText}
            </div>
          </div>
        </div>
        <div className={styles.offerText}>
          {/* <i class="fa-regular fa-certificate"></i> */}
          <div className={styles.littleLine}></div>
          <div className={styles.offerRtext}>
            هر ثبت نام موفق
            <span className={styles.equal}>=</span>
            ۳۰,۰۰۰ تومان اعتبار
          </div>
          <div className={styles.littleLine}></div>
          {/* <i class="fa-regular fa-certificate"></i> */}
        </div>
      </div>
      <SeperatorBlue />
    </>
  );
};

export default ReferralManage;
